export const noOptionsMessage = (e: { inputValue: string }) => {
  const { inputValue } = e;
  if (!inputValue) {
    return 'Start typing to search';
  }
  return `No results for ${inputValue}`;
};
